<template>
  <div class="card mgt-20px">
    <header class="header-card" >
      <p>{{ $t('addEditPlanMedia.information.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-3">
          <b-field
            v-if="!detail"
            :label="$t('addEditPlanMedia.information.code')">
            <b-input v-model="planMedia.code" disabled></b-input>
          </b-field>
          <div v-else>
            <p class="has-text-default is-italic">
              {{ $t('detailPlanMedia.information.code') }}
            </p>
            <p class="has-text-weight-bold">{{ planMedia.code }}</p>
          </div>
        </div>
        <div class="column is-3">
          <user-selector
            v-if="!detail"
            v-model="planMedia.commercialId"
            @input="setCommissions"
            :critere="(u) => [constantes.COMMERCIAL, constantes.DIRECTEUR_COMMERCIAL]
              .includes(u.profil)"
            :label="$t('addEditPlanMedia.information.gestionnaire')"
            obligatoire
          />
          <div v-else>
            <p class="has-text-default is-italic">
              {{ $t('detailPlanMedia.information.gestionnaire') }}
            </p>
            <p class="has-text-weight-bold">
              {{ getLibelleGestionnaire(planMedia.commercialId) }}
            </p>
          </div>
        </div>
        <div class="column is-3">
          <b-field
            v-if="!detail"
            :label="$t('addEditPlanMedia.information.statut')"
            class="obligatoire">
            <b-select v-model="planMedia.statut" expanded>
              <option
                v-for="items in constantes.PM_STATUS_TYPE"
                :key="items.value"
                :value="items.value">
                {{ $t(items.libelle) }}
              </option>
            </b-select>
          </b-field>
          <div v-else>
            <p class="has-text-default is-italic">
              {{ $t('detailPlanMedia.information.statut') }}
            </p>
            <p class="has-text-weight-bold">
              {{ getLibelleStatut(planMedia.statut) }}
            </p>
          </div>
        </div>
        <div class="column is-3" v-if="agences.length > 1 && !detail">
          <selection-agence
            v-model="planMedia.agenceId"
            set-first-agence-find
            obligatoire>
          </selection-agence>
        </div>
        <div class="column is-3">
          <b-field
            v-if="!detail"
            :label="$t('addEditPlanMedia.information.datePM')">
            <div class="columns is-vcentered" >
              <b-datepicker
                v-model="planMedia.datePM"
                class="column"
                icon="calendar-today"
                position="is-bottom-right"
                editable
                nearby-selectable-month-days
                show-week-number>
              </b-datepicker>
            </div>
          </b-field>
          <div v-else>
            <p class="has-text-default is-italic">
              {{ $t('detailPlanMedia.information.datePM') }}
            </p>
            <p class="has-text-weight-bold">
              {{ planMedia.datePM | formatDate }}
            </p>
          </div>
        </div>
        <div class="column is-3">
          <b-field
            v-if="!detail"
            :label="$t('addEditPlanMedia.information.dateSignature')">
            <div class="columns is-vcentered" >
              <b-datepicker
                v-model="planMedia.dateSignature"
                class="column"
                icon="calendar-today"
                position="is-bottom-right"
                editable
                nearby-selectable-month-days
                show-week-number>
              </b-datepicker>
            </div>
          </b-field>
          <div v-else>
            <p class="has-text-default is-italic">
              {{ $t('detailPlanMedia.information.dateSignature') }}
            </p>
            <p class="has-text-weight-bold">
              {{ planMedia.dateSignature | formatDate }}
            </p>
          </div>
        </div>
        <div class="column is-3">
          <b-field
            v-if="!detail"
            :label="$t('addEditPlanMedia.information.dateDebut')"
            class="obligatoire">
            <div class="columns is-vcentered" >
              <b-datepicker
                v-model="planMedia.dateDebut"
                class="column"
                icon="calendar-today"
                position="is-bottom-right"
                editable
                nearby-selectable-month-days
                show-week-number>
              </b-datepicker>
            </div>
          </b-field>
          <div v-else>
            <p class="has-text-default is-italic">
              {{ $t('detailPlanMedia.information.dateDebut') }}
            </p>
            <p class="has-text-weight-bold">
              {{ planMedia.dateDebut | formatDate }}
            </p>
          </div>
        </div>
        <div class="column is-3">
          <b-field
            v-if="!detail"
            :label="$t('addEditPlanMedia.information.dateFin')"
            class="obligatoire">
            <div class="columns is-vcentered" >
              <b-datepicker
                v-model="planMedia.dateFin"
                class="column"
                icon="calendar-today"
                position="is-bottom-right"
                editable
                nearby-selectable-month-days
                show-week-number>
              </b-datepicker>
            </div>
          </b-field>
          <div v-else>
            <p class="has-text-default is-italic">
              {{ $t('detailPlanMedia.information.dateFin') }}
            </p>
            <p class="has-text-weight-bold">
              {{ planMedia.dateFin | formatDate }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { PM_STATUS_TYPE } from '@/configuration/bodac/planMedia/planMediaConfig';
import SelectionAgence from '@/components/general/selectionAgence';
import userSelector from '@/components/commun/user/userSelector';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import { COMMERCIAL, DIRECTEUR_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    planMedia: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
    },
  },
  components: {
    SelectionAgence,
    userSelector,
  },
  data() {
    return {
      constantes: {
        PM_STATUS_TYPE,
        COMMERCIAL,
        DIRECTEUR_COMMERCIAL,
      },
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agences: 'agenceActive',
    }),
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    getLibelleGestionnaire(id) {
      const find = this.parametre(PARAMETRES_KEYS.utilisateur)
        .find((u) => u.id === id);
      if (find) return nomPrenomGetter(find);
      return '';
    },
    getLibelleStatut(value) {
      const find = PM_STATUS_TYPE.find((s) => s.value === value);
      if (find) return this.$t(find.libelle);
      return '';
    },
    setCommissions(commercialId) {
      if (this.planMedia.commissions.length > 1) return;
      if (!commercialId) this.planMedia.commissions = [];
      else {
        this.planMedia.commissions = [{
          commercialId: commercialId,
          pourcentageRepartition: 100,
          selected: false,
        }];
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.agences.length === 1) this.planMedia.agenceId = this.agences[0].id;
      await this.loadParametreUtilisateur();
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
